import {storeInstance} from '@aofl/store/dist/legacy';
import {deepAssign} from '@aofl/object-utils';
import {
  sdoNs,
} from '@modules/constants-enumerate';
import '@routes/dashboard/modules/teacher-dashboard/sdo';

const sdo = {
  namespace: sdoNs.MM_TEACHER_DASHBOARD,
  mutations: {

    /**
     * @return {Object}
     */
    init() {
      return {
        activeNodeId: null,
        studentInfo: {},
        nodes: {},
      };
    },
    setNodeInfo(subState, payload) {
      const nodes = {...subState.nodes};
      nodes[payload.id] = payload;
      return {
        ...subState,
        nodes,
        activeNodeId: payload.id
      };
    },
    setTeacherDashData(subState, payload) {
      return Object.assign(
        {...subState},
        {
          usage: payload?.usage,
          activityStatus: payload?.activity_statuses,
          studentActivity: payload?.student_activity,
          studentInfo: payload?.student_info,
          nodes: payload?.nodes,
          recommendedActivities: payload?.recommended_activities,
          activeInWeek: payload?.active_in_week,
        });
    },
  },
  decorators: [
    (nextState) => { // $actionItems
      const nextSubState = nextState[sdoNs.MM_TEACHER_DASHBOARD];
      const state = storeInstance.getState();
      const $studentInfo = {};
      if (typeof nextSubState.$studentInfo === 'undefined' ||
        nextSubState.studentInfo !== state[sdoNs.MM_TEACHER_DASHBOARD].studentInfo
      ) {
        for (const [studentId, student] of Object.entries(nextSubState.studentInfo)) {
          const capsLastNameFirstLetter = student.last_name?.charAt(0)?.toUpperCase();
          $studentInfo[studentId] = {
            id: studentId,
            first_name: student.first_name,
            last_name: student.last_name,
            initials: student.first_name ? student.first_name.charAt(0).toUpperCase() + capsLastNameFirstLetter : '',
            abbreviated: student.first_name ? student.first_name + ' ' + capsLastNameFirstLetter + '.' : '',
          };
        }

        nextState = deepAssign(nextState, sdoNs.MM_TEACHER_DASHBOARD, {
          $studentInfo,
        });
      }

      return nextState;
    },
  ],
};

storeInstance.addState(sdo);
